import Avatar1 from '../../assets/testimonial1.png'
import Avatar2 from '../../assets/testimonial2.png'
import Avatar3 from '../../assets/testimonial3.png'
import Avatar4 from '../../assets/testimonial4.png'
import Avatar5 from '../../assets/testimonial5.png'

const data = [
    {
        id: 1,
        quote: "It's truly amazing how you did exactly what I wanted with the little information I gave. You'll be my go-to developer from today. Highly recommend.",
        avatar: Avatar1,
        name: 'Mr Kenny',
        profession: 'Founder, Jovita Mart'
    },
    {
        id: 2,
        quote: "Right on time and exactly what we needed. I really like how the project turned out — my customers love it too. It was great collaborating with you, Jonah.",
        avatar: Avatar2,
        name: 'Mr Josh',
        profession: 'Co-founder'
    },
    {
        id: 3,
        quote: "Impressive work. Highly recommend. Jonah consistently delivers well-engineered solutions that hold up in production.",
        avatar: Avatar3,
        name: 'Mrs Chizoba Sylvester',
        profession: 'Regional HR Manager, British Council'
    },
    {
        id: 4,
        quote: "Finished ahead of schedule. Everything is modern, clean, and beautifully done. Jonah brings a level of professionalism that's hard to find.",
        avatar: Avatar4,
        name: 'Mr Brown',
        profession: 'Founder'
    },
    {
        id: 5,
        quote: "I like how the app turned out. Jonah took the brief and delivered something that exceeded what we had in mind. Incredible work.",
        avatar: Avatar5,
        name: 'Mr Petar',
        profession: 'Entrepreneur'
    }
]

export default data
